export const SUPPORTED_LOCALES = ["zh-Hans", "en"] as const;

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export type MessageValues = Record<string, boolean | number | string | null | undefined>;
